<template>
  <div>
    <DeleteRecord
      v-if="deleteRecordModal"
      :show="deleteRecordModal"
      :record="record"
      v-on:closeDeleteRecordModal="deleteRecordModal = false"
    />
    <div class="page-wrapper">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        loader="bars"
      ></loading>

      <div
        class="page-breadcrumb"
        style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
      >
        <div class="row">
          <div class="col-md-5 align-self-center">
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item h6 font-16 mylink">
                <router-link class="mylink" to="/records">{{
                  $t("back-to")
                }}</router-link>
              </li>
            </ol>
          </div>
          <div class="col-md-7 align-self-center">
            <div class="d-flex align-items-start justify-content-end py-2">
              <div v-click-outside="closeExport" class="btn-group">
                <button
                  id="btnGroupDrop1"
                  type="button"
                  class="btn btn-primary dropdown-toggle"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  @click.prevent="exportShow = !exportShow"
                >
                  {{ $t("exp") }}
                </button>
                <div class="dropdown-menu" v-bind:class="{ show: exportShow }">
                  <a
                    href="javascript:void(0)"
                    class="dropdown-item mb-2"
                    @click.prevent="exportRecord('csv')"
                    style="
                      border: 1px solid rgba(0, 0, 0, 0.4);
                      border-radius: 5px;
                    "
                  >
                    {{ $t("exp-csv") }}
                  </a>
                  <a
                    href="javascript:void(0)"
                    class="dropdown-item"
                    style="
                      border: 1px solid rgba(0, 0, 0, 0.4);
                      border-radius: 5px;
                    "
                    @click.prevent="exportRecord('pdf')"
                  >
                    {{ $t("exp-pdf") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid pt-0">
        <h4 v-if="record.record" class="p-b-20">
          {{ this.record.record.name }}
        </h4>
        <div v-if="record.stats && record.stats.length == 0">
          <div class="card">
            <div class="card-body p-4" align="center">
              <h4 class="mb-0 gray4">
                {{ $t("no-temp-humid") }}
              </h4>
            </div>
          </div>
        </div>
        <div v-else class="card">
          <div class="card-body">
            <div
              class="d-flex justify-content-space-around col-md-8 col-lg-6 mx-auto"
              v-if="
                record.device &&
                  (record.device.type == 'mote' ||
                    record.device.type == 'gps-vt')
              "
            >
              <div class="btn-container">
                <button
                  @click="showGraph('temp')"
                  :disabled="tempGraph == true"
                  id="graphselect"
                >
                  {{ $t("temp") }}
                </button>
              </div>
              <div class="btn-container">
                <button
                  @click="showGraph('humi')"
                  :disabled="humiGraph == true"
                  id="graphselect"
                >
                  {{ $t("humid") }}
                </button>
              </div>
            </div>
            <div ref="chartContent" id="my-node">
              <CombinedChart
                :tempGraph="tempGraph"
                :humiGraph="humiGraph"
                :stats="record.stats"
              />
            </div>
          </div>
        </div>
        <!-- <div class="col-12"> -->
        <div class="card" v-if="record.device">
          <div class="card-body">
            <CombinedTable :stats="record.stats" :type="record.device.type" />
          </div>
        </div>
        <!-- </div> -->
        <div class="card">
          <div class="card-body">
            <div
              class="row"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div class="col-md-8">
                <h5>{{ $t("del_rec") }}</h5>
                <p class="mb-0">
                  {{ $t("del_perm") }}
                </p>
              </div>
              <div class="col-md-4 deleterecord">
                <button
                  class="btn btn-danger"
                  @click.prevent="deleteRecordModal = true"
                >
                  {{ $t("del_rec") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer text-center">
        &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import DeleteRecord from "../Modals/DeleteRecord";
// import CombinedChart from "../../components/Devices/CombinedChart";
import CombinedTable from "../../components/Devices/CombinedTable";
import "vue-loading-overlay/dist/vue-loading.css";
import jsPDF from "jspdf";
import domtoimage from "dom-to-image";

// import html2canvas from "html2canvas";
import moment from "moment";
import vClickOutside from "v-click-outside";

export default {
  name: "ViewRecord",
  components: {
    DeleteRecord,
    CombinedChart: () =>
      import(
        /* webpackPrefetch: true */ "../../components/Devices/CombinedChart"
      ),
    CombinedTable,
    Loading,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      deleteRecordModal: false,
      exportShow: false,
      tempGraph: true,
      humiGraph: false,
      excursions: {},
      H: 85000,
      R: 8.31,
      mkt: 0,
    };
  },
  mounted() {
    this.getBusinessProfile();

    this.getSingleRecord(this.$route.params.id)
      .then(() => {
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        this.Errormssg =
          error.response.data.message[0].toUpperCase() +
          error.response.data.message.slice(1);
        // error.response can be null
        if (error.response) {
          console.error(error.response.data.message);
        }
      });
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters(["record", "businessprofile"]),
  },
  methods: {
    ...mapActions(["getSingleRecord", "getBusinessProfile"]),
    exportRecord(type) {
      // console.log(type);
      this.exportShow = false;
      var head = [
        [
          "Day",
          "Date",
          "Time",
          "Temperature (°C)",
          "Humidity (%)",
          "Min Temp (°C)",
          "Max Temp (°C)",
          "Min Humidity (%)",
          "Max Humidity (%)",
          "Battery Level (%)",
        ],
      ];
      if (this.record.device.type !== "mote") {
        head[0].splice(4, 1);
        head[0].splice(6, 1);
        head[0].splice(6, 1);
        // console.log(this.tableColumns)
      }
      var body = [];
      this.excursions = {
        temperature: {
          longest: Number.NEGATIVE_INFINITY,
          shortest: Number.POSITIVE_INFINITY,
          count: 0,
          indexes: [],
          total: 0,
        },
        humidity: {
          longest: Number.NEGATIVE_INFINITY,
          shortest: Number.POSITIVE_INFINITY,
          count: 0,
          indexes: [],
          total: 0,
        },
      };
      let length = this.record.stats.length;
      const HR = this.H / this.R;
      // eslint-disable-next-line no-unused-vars
      let sumTemp = 0;
      for (let i = 0; i < length; i++) {
        let temp = this.record.stats[i].temperature;
        let maxTemp = this.record.stats[i].maxTemp;
        let minTemp = this.record.stats[i].minTemp;
        let humidity = this.record.stats[i].humidity;
        let maxHumi = this.record.stats[i].maxHumidity;
        let minHumi = this.record.stats[i].minHumidity;
        let battery = this.record.stats[i].battery;
        let tempexcursions = this.excursions.temperature.indexes.length;
        let humiexcursions = this.excursions.humidity.indexes.length;
        let tempExp = Math.exp(-HR / (temp + 273.15));
        sumTemp += tempExp;

        let [day, date, time] = moment(
          this.record.stats[i].createdAt,
          "x",
          true
        )
          .format("ddd, MMM Do YYYY, hh:mm a")
          .split(", ");

        if (this.record.device.type == "mote") {
          body.push([
            day,
            date,
            time,
            temp,
            humidity,
            minTemp,
            maxTemp,
            minHumi,
            maxHumi,
            battery,
          ]);
        } else {
          body.push([day, date, time, temp, minTemp, maxTemp, battery]);
        }

        if (i == 0 && (temp < minTemp || temp > maxTemp)) {
          this.excursions.temperature.indexes.push([i]);
          this.excursions.temperature.count++;
        }
        if (i == 0 && (humidity < minHumi || humidity > maxHumi)) {
          this.excursions.humidity.indexes.push([i]);
          this.excursions.humidity.count++;
        }
        if (i !== 0 && i !== length - 1) {
          let prevtemp = this.record.stats[i - 1].temperature;
          let prevmaxTemp = this.record.stats[i - 1].maxTemp;
          let prevminTemp = this.record.stats[i - 1].minTemp;
          let prevhumi = this.record.stats[i - 1].humidity;
          let prevmaxhumi = this.record.stats[i - 1].maxHumidity;
          let prevminhumi = this.record.stats[i - 1].minHumidity;
          if (
            (temp < minTemp || temp > maxTemp) &&
            prevtemp >= prevminTemp &&
            prevtemp <= prevmaxTemp
          ) {
            this.excursions.temperature.indexes.push([i]);
            this.excursions.temperature.count++;
          }

          if (
            temp >= minTemp &&
            temp <= maxTemp &&
            (prevtemp < prevminTemp || prevtemp > prevmaxTemp)
          ) {
            this.excursions.temperature.indexes[tempexcursions - 1].push(i);
            let initialIndex = this.excursions.temperature.indexes[
              tempexcursions - 1
            ][0];
            let initialTime = this.record.stats[initialIndex].createdAt;
            let finalTime = this.record.stats[i].createdAt;

            // Convert excursion time to hours from milliseconds
            let excursionTime =
              moment(finalTime, "x").diff(moment(initialTime, "x")) / 3600000;

            if (excursionTime > this.excursions.temperature.longest) {
              this.excursions.temperature.longest = excursionTime.toFixed(2);
            }
            if (excursionTime < this.excursions.temperature.shortest) {
              this.excursions.temperature.shortest = excursionTime.toFixed(2);
            }
            this.excursions.temperature.total += excursionTime;
          }

          if (
            (humidity < minHumi || humidity > maxHumi) &&
            prevhumi >= prevminhumi &&
            prevhumi <= prevmaxhumi
          ) {
            this.excursions.humidity.indexes.push([i]);
            this.excursions.humidity.count++;
          }

          if (
            humidity >= minHumi &&
            humidity <= maxHumi &&
            (prevhumi < prevminhumi || prevhumi > prevmaxhumi)
          ) {
            this.excursions.humidity.indexes[humiexcursions - 1].push(i);
            let initialIndex = this.excursions.humidity.indexes[
              humiexcursions - 1
            ][0];
            let initialTime = this.record.stats[initialIndex].createdAt;
            let finalTime = this.record.stats[i].createdAt;
            let excursionTime =
              moment(finalTime, "x").diff(moment(initialTime, "x")) / 3600000;
            if (excursionTime > this.excursions.humidity.longest) {
              this.excursions.humidity.longest = excursionTime.toFixed(2);
            }
            if (excursionTime < this.excursions.humidity.shortest) {
              this.excursions.humidity.shortest = excursionTime.toFixed(2);
            }
            this.excursions.humidity.total += excursionTime;
          }
        }
        // if (i == length - 1 && (temp < minTemp || temp > maxTemp)) {
        if (
          i == length - 1 &&
          (temp < minTemp || temp > maxTemp) &&
          tempexcursions > 0
        ) {
          this.excursions.temperature.indexes[tempexcursions - 1].push(i);
          let initialIndex = this.excursions.temperature.indexes[
            tempexcursions - 1
          ][0];
          let initialTime = this.record.stats[initialIndex].createdAt;
          let finalTime = this.record.stats[i].createdAt;

          // Convert excursion time to hours from milliseconds
          let excursionTime =
            moment(finalTime, "x").diff(moment(initialTime, "x")) / 3600000;

          if (excursionTime > this.excursions.temperature.longest) {
            this.excursions.temperature.longest = excursionTime.toFixed(2);
          }
          if (excursionTime < this.excursions.temperature.shortest) {
            this.excursions.temperature.shortest = excursionTime.toFixed(2);
          }
          this.excursions.temperature.total += excursionTime;
        }
        if (i == length - 1 && (humidity < minHumi || humidity > maxHumi)) {
          this.excursions.humidity.indexes[humiexcursions - 1].push(i);
          let initialIndex = this.excursions.humidity.indexes[
            humiexcursions - 1
          ][0];
          let initialTime = this.record.stats[initialIndex].createdAt;
          let finalTime = this.record.stats[i].createdAt;
          let excursionTime =
            moment(finalTime, "x").diff(moment(initialTime, "x")) / 3600000;
          if (excursionTime > this.excursions.humidity.longest) {
            this.excursions.humidity.longest = excursionTime.toFixed(2);
          }
          if (excursionTime < this.excursions.humidity.shortest) {
            this.excursions.humidity.shortest = excursionTime.toFixed(2);
          }
          this.excursions.humidity.total += excursionTime;
        }
      }
      const expSumTemp = sumTemp / length;
      const overAll = Math.log(expSumTemp);
      const mkt = -HR / overAll;
      this.mkt = mkt - 273.15;
      // for (let i = 0; i < this.record.stats.length; i++) {

      // }
      if (type == "csv") {
        body.unshift(head);
        // console.log(body, "body");
        body = body.map((e) => e.join(",")).join("\n");
        let csvContent = "data:text/csv;charset=utf-8," + body;
        csvContent = encodeURI(csvContent);
        // // console.log(csvContent, "csv content");
        var link = document.createElement("a");
        link.setAttribute("href", csvContent);
        link.setAttribute(
          "download",
          `${this.record.record.name}_${this.record.record.device}.csv`
        );
        document.body.appendChild(link); // Required for FF

        link.click();
      } else {
        this.isLoading = true;
        this.exportShow = false;

        if (screen.width < "992") {
          document.getElementById("my-node").style.width = "1440px";
        }
        var node = document.getElementById("my-node");
        // //console.log(this.datatable);
        //console.log(this.record.stats);
        var temp =
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACSSURBVHgBtZLhDUAwEIWvYgAj2MAKHcEINmAUIxjBBmzABtjABueV/tG0XCW+5OXS5L72LinRHzBzjQymxoqaL1pbta8vCfg5siIjstuzWD5RSvVWpmgZ45Yo2ScZzE8vp2Hv3HOhWDDuxHcmqVixn8bt9e2sA/cWEnklPxu9gfEyZHFGNuecJJhGpLN/uxWLMRw/e4KbUYJBSgAAAABJRU5ErkJggg==";
        var humi =
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC3SURBVHgBtVEBDQIxDOxQgIRJwAIKeAc/JwwHOBgo4B08EnDw7wAclFvokqb8CHz4Sy69bL127YiWAjN7mgMYW36hnWvknwpMGL8rgIQGvIO9Mg1gFN18MpdEL5pFe9G58LrWtXS6iD7KXVIvCVPmaGYcpGMw57F4Vsr/MPUOzrkRcQ924NbmafNNaxhP6JKNXs5K7KiysDJrAjf8jkQ15E2ab9Lo7aZdpUhA2IE5eQTPGONK/8QT3xYjozfbPFEAAAAASUVORK5CYII=";
        var excursion =
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAYAAAB2HjRBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACmSURBVHgBlZEBEYMwDEVTFFTKJETCJDAHlTAJtYCC4WASNge7KRgOshR+70K5A/Lu/vUS8smnEDWISFQ9VUxe1NTLQiYvanrA/PMaI4wvnLw33zX1FedNNZl6dxtD5aI+6GcbvZnj2kyyJqPPNjpeZkmhDpow7xDChH7ZPGidkOirute5o0+ao6su2NbTWUz0evuRPGBzYWyfdSf8A86RvJhfuIn8B3iJ1TkqATN7AAAAAElFTkSuQmCC";
        var imgUrl =
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA5CAYAAAG39b7rAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAAEchJREFUeNqMjj0KwkAQhb/ZICjbWdjZexEtcgPLkFZLryCIZ7BWrKw8gndIESyiV0hSZWxcGNcffPCYYXgfb9zkkGJ92S1fPDxOiTOOSJv+PaxnBUZdL47oG1QkLZkvWfhrmvuSTwqQmqkC1HRq7rnZcUAFCL91AgYWGoeGL8AKuAENsLfviWmT6LZ9tggwByRAa2D2x5sAPAAAAP//YkIO/+gloRjxhDeOzrJ8hTFvMzAwMITy3EK3gAUjfpK47zK0cj5RreV8zMD7nxld+h8TWrwsYGBg+HCX6ef/p0y/PjMwMHigxd1fZBuOMjAw/GFgYBCA8nkYGBh2oNkAD6mTDAwM1mghJQA1+R6UvweWxhgZGBjMkZIFLC4+QmklKO2CbMMGYuMBAAAA//9iQg9nZOy0LIDhKGq8KCPH0am5eQySK90Z8JmBNX8hg2dMvxiSue8ynGD5wsAGcXQSAwPDBwYGBoZE7rsMcdx3GPgxows9V8Hz40akRP+fgYHhC5S+xsDA8H8W+8t3Mdx3XiVx361K4r7Ln8R9l4ERVf1/9OwJxZdgNp1iYGDwQ8oQjAwMDNxIyYCBgYFBiIGBQQy5tEDLRDD8n4GBIQGJbwOzZA4e7xIVsWigGjkjwCyZBTVsK9QlpxkYGH7BUjcey5nQgkYYKs6HJNaHXtx5QdkmDAwMbFAN6Wi+QS53/qMF1VuouAR6+QQAAAD//6yWsUvDUBDGf0ltqW0jooKggw5OoosOgoODUycRceju4KIoIkUEF8FJF+uqg5Oji4t/gOKgOIjUUhzaSRCcpEWiics9fD5emxYaCJe7d7l7uffdd2kKYZNWbs/WV3W9fLoVCd9ICA8HCV0tABPAkDL4DRnYPh2sV9Yrkv7rgw/gS/WJR4ylTCkqfmidW6bHsldiIOwihAOpe20wiJNLl1uGmxvlEAsdFjIldlIVfyxI9u52V8l6RX5aLJWJLvMuiLwAwnfnu2fOe86/uT4xnKTFP9GAAXAt3VsX/UVkTuz92ubqlrGZE9uG2KaalStlUMensT5vYYM8cK6hEODRTPJkSeaLrKnjETndLs+oJJOWtaSxY/VlhyIX20myqQW5MSibJv88l8A9sK9RjPJfMw/+WKP2Wc35QWS8AUEWpXR7QFXsKs6JjJB/5appSFHUfyd6n+ivxmGPa++MWOLMqGcXODKwvQJU6ODlAtvSSFfAtWQf7WSSXwAAAP//zJhNaFNBEMd/eWlS0+RRC6FVFEGrgqgXwZZSRARBJL2oCPZUD4pHaSoePCiepNRvr568iehRRCl4yEVBEEpN2iZBjCDFQ9tASxGS9TIPttNNmg8PDiy83Zn3MW9n/jP/9RqBatdwdZiOUa6nX3iedrKHVobX6h/42rHGSX+W3RtLji0vJCNWtSJqPO7ESgz5My5G04ycEwA637IjFQz91W2c8bOkY9/p2liYbgDvgVPAPaAnUOysRhnxs5S8PyRNpN2QfQNMA6+9dmPTAMtehdHEAik/x5V4gW4Tvh8mNGAgGiY0GSa05JswV+NFRvwc200H/1q0I0eE5NnZ/0l0HyRUMsAtAceMjCkD9FUj01UwFxLznWPx/Ggqkf12OZ6fG4vnuZiYp4IJSvY4UFbvKUux0zIuUGXb3gSqLkdui8EMsEvWSkAeGBDdaQHoYelgI3I9LKFkJF6LUliTO0z0sIG9ujuSztW3KnxR5o8dxOChRblzUvUndfXxJGHuWmtJgcc9wAHV0QayAvxyVJcQ0G9xTRxEI8ihwP6Q3KPJRyBLyrZLrl9qR57ZJx5WW67li3Wts/TnFoRmQs0f1An3bjXfV8PuknZk3ZofrPOCo6pNsj+2cwtHZpvI2xU1H2qE/XnAfqUs1NgNu2DEmgSVd44wcz2jF0gBH621t3IStenAxZXsIeCRtZW6Jz9mNasAiwrxGmEPIeCENV9zvGdR2pizwHHL9ge1Tws2wW/awfjtYefFKyHmga5PfXRB3RtIRq0nBFx61Pq69L32Wq+i056tDxwZFA/nBFEG5Y+kBTVs76/rbW1DVgVclhuw/S07VrcgXrOSfUr668+CLgGUPhHvn/Ifyl9mrTUkiigKfzO767pqbW6JxfawpLe9iCIw6kdUEAVC1I/8UxlBEFH9UajoJb2gBwQVFEUviTKyB4FkP8r6EUSU9CBiKzNtU7Oyclc3Z/qxZ/J2vDOz7irtAXHn3nPvzLlzz7nn+87Elf36Ls/Hm1Ob7TLffLvsuPDCsl7JfBPKfmOQTXFEt17LtWISt65aMUJOANMoKhVQ+iNlnD6pkf9riFd3YE6/56hXO2Tm/CZ/ygAw0WAERelQdEz31uBzYoaMBbCQckB/3FtrkO7C6vQAmpSIbHE8FImWA7gkdqbrKg67GzBQc/WIvJLIDTpo7wC4lJCP+LUUFGUE4IvSeBAoiKtUpdkD4HzXUazjpSOEl85QXOwyk5DwuzVhZ8/SXFiU8Qof1HYM1lKgAD8ArCUCexQVS6BBxzelExvT3sOhK8nh7N0wOFTs8HzEjP41qHJ9h1tXcwHsVACfA8oXBxQE1QiK0gPI7AN02GuGGIlUlu5CWUozijIC+gjNfeVgasP6Yk8tij21KE2t7zMjZIacZElZiPZ6DuU+DwA8FzLiaqOsYyBJHRjYDu1xnvfpmBeOUFNQjYwPqhGElb9ZjZ8oVV0CqX08ptD8ol6AntspM8RDSmskzGklgDLiFfMppIIy4tmEU7IFbP9LB3KztZQpevRBxHJUGYGwqZJFnUl513G63kf51SQJ0OoUeOpufCYkYChiA24MCcawXW8hWoAWpYHu0yG0vQUwD0Ax061jWGkkN+QMG7CXtnwegaklMW7TuTSuTQKihhBgMqSRdP10HzeVFb5S0lolccHhBAIVCRxXVEQrjIa0ENXDV/KZjRFnANw36WsDcI+1ZUv0WshHZvEILzuP+WKpVoBekA02huy26GskNsaQEzZzbWXXzSZ6n6yi1kOTQdU2N/9pQQxksr4Km7kmMB8yk0dWhnTEfSaah3VFggqtRPxOIGyh125lyESTQaNjOA/NyDgOYxfYzFUXA6cFIuv+cXZRSk0GHUrg0M1k4XmbjX45uzaj7CeLb1ElRsSQxRDK6YxrilcGSMZfs4h+R1jbO4neaXadrhJmEKWeeKRK+v85hofVbfqeMFq1gNqPEStTjq6PTYYygs5PfaUASigKrmL3SFNN9vgw2svDJCd3T0UT5mxlfevoDSwV2moQLRBx3S10WGdJgoaHR5eVLG6HARTCvvStSXI02R732pxJJULi6AWw3URvHLpqyQCQw539LFlsMHgeSvQK2YqBsYC8xOAW+u6yvqNCXxb5oHG9n+nuonYnpSjGRz+v8W/t+u8bSbNZ8QPC7+29CCOaKcO1k04KyxE7PPKLHOoiRa6pRCSXSxy5AkkofGutAHCTgM9t5oRg2CLpDHEyRkImYWJHmpLZkN/oqsstIK7oOv2dE5y+DUksf9i5ttgoqjD8zaW7y+6WLhRooDSkKQYEURPT4pMYLw9SJShWLIWAGEPUQAIBQYJRxIApoImGeIMEobQGlBdAUUIDD7YIUZtAoeWSlIJcJdAWWi7dOT6cb7PT7ZzZ2bZQiP2TSdOe6dnZc85/+/7vH72nQGSv4HdJWZEXADzZ9XbVhrkV3ZnjxPoFKCkr6jEKyYMAxjuYUIGg0BEUeqpoqT3wyGf2nQbJG7iXz3HPje9dleGWHzt8VzElXI8qswUhGF4RYAFZsbwCWVsT9Os5AKoZ3oa9TOSHjiqzBVPC9djhu4rhlv//uyFRCESEiSYtis8D57Es0Aif0JEtkW+3sxogVrQWku2ex8jyT/qH9YizEB0/d4Blol0TmBo6jnWBC2jSoogIszc0xIAk/DjV2nfrvXEKBICIMHHCuInC9GMYnVGD/WYzsi2faoFuE7R7FpKhWQZZshgLSQbaq0r+DKFhkEjDB8EzmBg+BhMagsLoTUMloO4JiOq9raIRYSLXCmB1v3OYH2xAtuVHVmeNsZhFZAEoYmCeC2AG05K1SCgeW5CMw0vGHbwUrsMBswU595l56nWTpc6QBYZYaThqtGF8xmFM6H8EXwUu4se0K2jTLESECRPae0JWJTdQS/Igiw9/EIZos29Ekx7Fc+m1mB06BR80hHtXKx6sDYnpsQYg0zIRFgYOGdfxs+8aisPHMSlchyYtCr/QPwwKfTmAoQa0jIgwl+vQFqYJDbFrhOXHgmADXgnXww8dmZbZY9Sf+2VDBkC2Lc2DbIVZQ7hzDuIteXdrg4oyrbSZBrS02aGTeDm9Lv3xSE12jdE6a5/Z/OaYyF8jisL1mZPT6xG7CvofxmGjFXlRv2ojxgGYDtn3uYow8ApIWlcxnJs2vITl+cTnVjHIWEdY68UEUEdzW3fVwOdEXARkAWkXJK1kKSRR9GPIOs0BW4Qwn3iyUEUQnLtdMR7rJn2S5kcA2CqALzXACAkjKySM5jHtoYY1gXN7vvNfrB7THmoICePfdGEUpgsD6cJAhjBgQrNvxhwCpPaews30SUv43MsYNJSjY/H4JDfPSYoJRwtayoNEfpdAdnq8w83ZYQOn9jEabPSyITEsUEB23qRa0/8M7hXGqoSfiRIi9FadALSGmAS2AmiyAPigJS56Yp0sg75F8OBkdVFR87h5N23P9BHnLUfqnS8TIEnAhck2ZDR3+RmXyfYQpYsBwkGe5lUeH+Yaf/6jGB8GWUeI+eaNPJ0jIdk5g1xSFfvf5/KzClye5Wtm+0N58DRIQv54SBaqvff7PHMgixrjhhNXcN7BnDcMyaZYAVlv9+RDBvJUquQHG2C3HfFSQxtP4VKOz0jyWW02bFkdcMlTZDBy2oJ4lUp48IWfQs18bYKsNWq09TtpyqI2LTtIcz2K943iQbnBsTwXE68RZt7JNYry//6GpEAOZB7l6ot0AO/DuTMC9BvFHjWgLMnp0Tws7PNQkybcUJZGYuqLFeNneWrrUjQxMU1ZDuAxlwO7wON8lUk2RegAZioGWxCn+nuVL1ww+mQ+6QySs1zUEJWMZlTyCVzKQh6syGQXjV6Z4nyVcOGO6EjgPtjklFs04OInjnqw807iQ+cOmkQNUWlJP5v/cZLD3YjAB6FjK7ddjvFKVc67bYiKEjEYnTmF8LCowxRjt5KYHj1JXuQ2fsvtS6J7JcJrtBZOkot4V2AqEnT7kvsUY9mIvwbGq0yDmjjk64FcUaVlNyAheJUs78bn3oath91hYd9Ncb6RkPR9x/3Q6QhV9LLN6MwoVMk4AN8k0Z67JSNoXssV449CclW72r1S6jK2CGrCpNMaVCbkWR3Gdch3BzzhYrer6RdK0JnKOYjoay0z3J7Qgq5IzAyWQNZHVOallad9ostc/SE7Eur4PDv5/V5Ikn8cAfCUy4HZSNOa4zJPOGaTj/BLbVTc+DDD2ssJcMdlAFvRkQWqkutJfIjwsOheCowzIWnt1xXj+Yi/t8jpaqKmj+L9hcTwdjMzV1F1x0JymZ3mbHCJZjsEJ4lO8g1bglOb4ildg3g/mJNcsp1AJwkkWXAT6qpgYmDyOzPvAuJt3ZEGyJpLzJoMhmzhr+3CXDcgW8D2KsYzdRcVfMR2KodxordoMxdDNmMU2O5ZxLA1oMjSYxy7hXSEswiNzCQQ97oLrAKakEm8dzqvOQCmQnawOMkhyJ4Kjc/1GiRXr5Jm+DQXvJGwyH7IbplXeXA0mrpN6EhsrLatzxBm/hWQ3TSN1KKzzNK3Mbk2CKX8RhCyFJKRuYRoRymARV7rIec50XpqQilkoeiQ7R6DZs1pznJbTnOaD/Q9oZFNkIWmXzyYrV28dwuvb2ky2zx8h1tcnHnMlsfSBOXSxj8E4Gn6j59cQt1EuUxsbBrN4QhqUQ5xrFivon1Dt/NQr4QkbK7i7+X2xcukw6sgbhVKARHdCAmrj3QYvwAJcfeJR1gANueVT9PxK+LvNIxdFhfdSvj7SReHdZCIakvfUqe2IWno3EHlFOUYHiOdOjr48X1L3LUNuQNZExkDWU/YRifc5GGOZkY1q5mAxd5/U9O3vKnLfwMAWN8akdls26sAAAAASUVORK5CYII=";

        var companyImg = this.businessprofile.image;
        var c = document.createElement("canvas");
        var img = document.createElement("img");
        img.crossOrigin = "anonymous";
        img.src = companyImg;
        var doc = new jsPDF();

        setTimeout(() => {
          c.height = img.naturalHeight;
          c.width = img.naturalWidth;
          var ctx = c.getContext("2d");

          ctx.drawImage(img, 0, 0, c.width, c.height);
          var base64String = c.toDataURL("image/png");
          var base64Img = base64String.replace(
            /^data:image\/(png|jpg);base64,/,
            ""
          );
          doc.addImage(base64Img, "JPEG", 175, 5, 25, 11);
        }, 1000);
        doc.addImage(imgUrl, "JPEG", 15, 8, 25, 8);
        // doc.addImage(imgUrl, "JPEG", 15, 10, 30, 18);
        // doc.setFontSize(10);
        doc.setFont("times");
        doc.setDrawColor(225, 231, 236);
        doc.line(0, 22, 215, 22); //horizontal

        // doc.text(15, 40, `Record Name:`);
        // doc.text(55, 40, `${this.record.record.name}`);
        // doc.text(15, 48, `Device ID:`);
        // doc.text(55, 48, `${this.record.record.device}`);
        // doc.setFontSize(14);
        // doc.text(15, 60, `SUMMARY`);
        // doc.setLineWidth(0.5);
        // doc.line(15, 61, 200, 61);
        // doc.setFontSize(10);
        // doc.text(15, 68, `Start Time:`);
        // doc.text(
        //   55,
        //   68,
        //   `${moment(this.record.record.startTime, "x", true).format(
        //     "ddd, MMM Do YYYY, hh:mm a"
        //   )}`
        // );
        // doc.text(15, 76, `End Date:`);
        // doc.text(
        //   55,
        //   76,
        //   `${moment(this.record.record.endTime, "x", true).format(
        //     "ddd, MMM Do YYYY, hh:mm a"
        //   )}`
        // );
        doc.setFontSize(12);
        doc.setTextColor(51, 51, 51);
        doc.text(15, 32, "Quality assurance report");
        doc.setFontSize(10);
        doc.setTextColor(134, 147, 165);
        doc.text(
          175,
          32,
          `${moment(this.record.record.startTime, "x", true).format(
            "ddd Do MMM, YYYY"
          )}`
        );
        doc.setDrawColor(134, 147, 165);
        // doc.line(15, 40, 200, 40); //horizontal
        // doc.line(15, 110, 200, 110); //horizontal
        // doc.line(15, 40, 15, 110); //vertical
        // doc.line(200, 40, 200, 110); //vertical
        doc.setFillColor(255, 255, 255);
        doc.roundedRect(15, 40, 185, 70, 1, 1, "FD");

        doc.setTextColor(34, 34, 34);
        doc.text(20, 48, "Report Details");

        doc.setTextColor(134, 147, 165);
        doc.text(20, 56, "Record Name");
        doc.text(20, 64, "Device Tag");
        doc.text(20, 72, "Start Date");
        doc.text(20, 80, "End Date");
        doc.text(20, 88, "Description");
        doc.text(
          20,
          96,
          `Mean Kinetic Temperature (MKT) : ${Math.floor(this.mkt)}°C`
        );

        doc.setTextColor(34, 34, 34);
        doc.text(50, 56, `${this.record.record.name}`);
        doc.text(50, 64, `${this.record.record.device}`);
        doc.text(
          50,
          72,
          `${moment(this.record.record.startTime, "x", true).format(
            "ddd, MMM Do YYYY, hh:mm a"
          )}`
        );
        doc.text(
          50,
          80,
          `${moment(this.record.record.endTime, "x", true).format(
            "ddd, MMM Do YYYY, hh:mm a"
          )}`
        );

        if (this.record.device.type == "mote") {
          doc.text(
            50,
            88,
            `Temperature & Humidity monitoring for ${this.record.record.device}`
          );
        } else {
          doc.text(
            50,
            88,
            `Temperature monitoring for ${this.record.record.device}`
          );
        }

        doc.setFillColor(255, 255, 255);
        doc.roundedRect(15, 120, 185, 100, 1, 1, "FD");

        doc.circle(19, 234, 4);
        doc.setFillColor(64, 74, 87);
        doc.circle(19, 234, 2, "FD");
        doc.addImage(temp, "JPEG", 17.5, 232.6, 3, 3);
        doc.line(23, 234, 66, 234); //horizontal
        doc.text(24, 233, "Temperature Chart Summary");
        doc.text(
          25,
          240,
          "This provide an overview of how the device experienced temperature changes within the selected phase."
        );

        doc.setFillColor(246, 225, 225);
        doc.setDrawColor(253, 77, 77);
        doc.setTextColor(253, 77, 77);
        doc.roundedRect(15, 250, 80, 17, 2, 2, "FD");
        doc.setFillColor(253, 77, 77);
        doc.circle(24, 258, 2, "FD");
        doc.addImage(temp, "JPEG", 22.5, 256.6, 3, 3);
        doc.text(
          28,
          259,
          `Maximum Temperature : ${this.record.device.settings.maxTemp}°C`
        );

        doc.setFillColor(255, 239, 203);
        doc.setDrawColor(250, 188, 45);
        doc.setTextColor(250, 188, 45);
        doc.roundedRect(105, 250, 80, 17, 2, 2, "FD");
        doc.setFillColor(250, 188, 45);
        doc.circle(114, 258, 2, "FD");
        doc.addImage(temp, "JPEG", 112.5, 256.6, 3, 3);
        doc.text(
          118,
          259,
          `Minimum Temperature : ${this.record.device.settings.minTemp}°C`
        );

        doc.setFillColor(214, 245, 222);
        doc.setDrawColor(40, 168, 74);
        doc.setTextColor(40, 168, 74);
        doc.roundedRect(15, 275, 80, 17, 2, 2, "FD");
        doc.setFillColor(40, 168, 74);
        doc.circle(24, 283, 2, "FD");
        doc.addImage(excursion, "JPEG", 22.5, 281.6, 3, 3);
        doc.text(
          28,
          284,
          `Number of Excursions : ${this.excursions.temperature.count}`
        );
        // doc.text(28, 284, `Number of Excursions : ${this.record.tempOverview.excursions}`);

        let maxExcursion;
        let minExcursion;
        let avgExcursion;
        let maxHumiExcursion;
        let minHumiExcursion;
        let avgHumiExcursion;
        if (this.excursions.temperature.count !== 0) {
          maxExcursion = this.excursions.temperature.longest + "hours";
          minExcursion = this.excursions.temperature.shortest + "hours";
          avgExcursion =
            (
              this.excursions.temperature.total /
              this.excursions.temperature.count
            ).toFixed(2) + "hours";
        } else {
          avgExcursion = minExcursion = maxExcursion = "-";
        }

        if (this.excursions.humidity.count !== 0) {
          maxHumiExcursion = this.excursions.humidity.longest + "hours";
          minHumiExcursion = this.excursions.humidity.shortest + "hours";
          avgHumiExcursion =
            (
              this.excursions.humidity.total / this.excursions.humidity.count
            ).toFixed(2) + "hours";
        } else {
          maxHumiExcursion = minHumiExcursion = avgHumiExcursion = "-";
        }

        doc.setFillColor(202, 245, 214);
        doc.setDrawColor(2, 43, 13);
        doc.setTextColor(2, 43, 13);
        doc.roundedRect(105, 275, 80, 17, 2, 2, "FD");
        doc.setFillColor(2, 43, 13);
        doc.circle(114, 283, 2, "FD");
        doc.addImage(excursion, "JPEG", 112.5, 281.6, 3, 3);
        doc.text(118, 284, `Longest Excursion Duration : ${maxExcursion}`);
        // doc.text(118, 284, `Longest Excursion Duration : ${this.record.tempOverview.highest} hours`);

        // doc.line(15, 120, 200, 120); //horizontal
        // doc.line(15, 270, 200, 270); //horizontal
        // doc.line(15, 120, 15, 270); //vertical
        // doc.line(200, 120, 200, 270); //vertical

        this.tempGraph = true;
        // this.humiGraph = true;
        // var canvasElement = document.createElement("canvas");
        setTimeout(() => {
          // html2canvas(this.$refs.chartContent, { canvas: canvasElement })
          //   .then(function(canvas) {
          //     const img = canvas.toDataURL("image/jpeg", 0.8);
          //     doc.addImage(img, "JPEG", 20, 125, 175, 90);
          //     //console.log("imageadded");
          //     // doc.save("sample1.pdf");
          //     return 90;
          //   })
          domtoimage
            .toPng(node)
            .then(function(dataUrl) {
              doc.addImage(dataUrl, "png", 20, 125, 175, 90);
              // var img = new Image();
              // img.src = dataUrl;
              // document.body.appendChild(img);
            })
            .then(() => {
              // doc.addPage();
              // doc.autoTable({ head, body });
              // this.tempGraph = true;
              doc.addPage();

              doc.setFillColor(218, 226, 239);
              doc.setDrawColor(105, 137, 194);
              doc.setTextColor(105, 137, 194);
              doc.roundedRect(15, 10, 80, 17, 2, 2, "FD");
              doc.setFillColor(105, 137, 194);
              doc.circle(24, 18, 2, "FD");
              doc.addImage(excursion, "JPEG", 22.5, 16.6, 3, 3);

              doc.text(28, 19, `Shortest Excursion Duration : ${minExcursion}`);

              doc.setFillColor(238, 243, 246);
              doc.setDrawColor(183, 195, 205);
              doc.setTextColor(64, 74, 87);
              doc.roundedRect(105, 10, 80, 17, 2, 2, "FD");
              doc.setFillColor(134, 147, 165);
              doc.circle(114, 18, 2, "FD");
              doc.addImage(excursion, "JPEG", 112.5, 16.6, 3, 3);

              doc.text(118, 19, `Average Excursion Duration : ${avgExcursion}`);

              if (this.record.device.type == "mote") {
                this.tempGraph = false;
                this.humiGraph = true;
                setTimeout(() => {
                  domtoimage
                    .toPng(node)
                    .then(function(dataUrl) {
                      doc.setFillColor(255, 255, 255);
                      doc.roundedRect(15, 50, 185, 100, 2, 2, "FD");
                      doc.addImage(dataUrl, "png", 20, 55, 175, 90);
                    })
                    .then(() => {
                      doc.circle(19, 164, 4);
                      doc.setFillColor(64, 74, 87);
                      doc.circle(19, 164, 2, "FD");
                      doc.line(23, 164, 62, 164); //horizontal
                      doc.text(24, 163, "Humidity Chart Summary");
                      doc.addImage(humi, "JPEG", 17.5, 162.6, 3, 3);
                      doc.text(
                        25,
                        170,
                        "This provide an overview of how the device experienced humidity changes within the selected phase."
                      );

                      doc.setFillColor(246, 225, 225);
                      doc.setDrawColor(253, 77, 77);
                      doc.setTextColor(253, 77, 77);
                      doc.roundedRect(15, 180, 80, 17, 2, 2, "FD");
                      doc.setFillColor(253, 77, 77);
                      doc.circle(24, 188, 2, "FD");
                      doc.addImage(humi, "JPEG", 22.5, 186.6, 3, 3);
                      doc.text(
                        28,
                        189,
                        `Maximum Humidity : ${this.record.device.settings.maxHumidity}%`
                      );

                      doc.setFillColor(255, 239, 203);
                      doc.setDrawColor(250, 188, 45);
                      doc.setTextColor(250, 188, 45);
                      doc.roundedRect(105, 180, 80, 17, 2, 2, "FD");
                      doc.setFillColor(250, 188, 45);
                      doc.circle(114, 188, 2, "FD");
                      doc.addImage(humi, "JPEG", 112.5, 186.6, 3, 3);
                      doc.text(
                        118,
                        189,
                        `Maximum Humidity : ${this.record.device.settings.minHumidity}%`
                      );

                      doc.setFillColor(214, 245, 222);
                      doc.setDrawColor(40, 168, 74);
                      doc.setTextColor(40, 168, 74);
                      doc.roundedRect(15, 205, 80, 17, 2, 2, "FD");
                      doc.setFillColor(40, 168, 74);
                      doc.circle(24, 213, 2, "FD");
                      doc.addImage(excursion, "JPEG", 22.5, 211.6, 3, 3);
                      doc.text(
                        28,
                        214,
                        `Number of Excursions : ${this.excursions.humidity.count}`
                      );
                      // doc.text(28, 214, `Number of Excursions : ${this.record.humOverview.excursions}`);

                      doc.setFillColor(202, 245, 214);
                      doc.setDrawColor(2, 43, 13);
                      doc.setTextColor(2, 43, 13);
                      doc.roundedRect(105, 205, 80, 17, 2, 2, "FD");
                      doc.setFillColor(2, 43, 13);
                      doc.circle(114, 213, 2, "FD");
                      doc.addImage(excursion, "JPEG", 112.5, 211.6, 3, 3);

                      doc.text(
                        118,
                        214,
                        `Longest Excursion Duration : ${maxHumiExcursion}`
                      );

                      doc.setFillColor(218, 226, 239);
                      doc.setDrawColor(105, 137, 194);
                      doc.setTextColor(105, 137, 194);
                      doc.roundedRect(15, 230, 80, 17, 2, 2, "FD");
                      doc.setFillColor(105, 137, 194);
                      doc.circle(24, 238, 2, "FD");
                      doc.addImage(excursion, "JPEG", 22.5, 236.6, 3, 3);

                      doc.text(
                        28,
                        239,
                        `Shortest Excursion Duration : ${minHumiExcursion}`
                      );

                      doc.setFillColor(238, 243, 246);
                      doc.setDrawColor(183, 195, 205);
                      doc.setTextColor(64, 74, 87);
                      doc.roundedRect(105, 230, 80, 17, 2, 2, "FD");
                      doc.setFillColor(134, 147, 165);
                      doc.circle(114, 238, 2, "FD");
                      doc.addImage(excursion, "JPEG", 112.5, 236.6, 3, 3);

                      doc.text(
                        118,
                        239,
                        `Average Excursion Duration : ${avgHumiExcursion}`
                      );

                      if (screen.width < "992") {
                        document.getElementById("my-node").style.width = "100%";
                      }
                      // doc.text(118, 239, `Average Excursion Duration : ${this.record.humOverview.average} hours`);

                      this.humiGraph = false;
                      this.tempGraph = true;
                      this.isLoading = false;
                      doc.save(
                        `${this.record.record.name}_${this.record.record.device}.pdf`
                      );
                    });
                }, 500);
              } else {
                // if (screen.width >= "992") {
                //   document.getElementById("cardContainer").style.maxWidth =
                //     "66.66666667%";
                //   document.getElementById("cardContainer").style.flex =
                //     "0 0 66.66666667%";
                // } else {
                //   document.getElementById("my-node").style.width = "100%";
                // }

                // setTimeout(() => {
                //   domtoimage
                //     .toPng(mapCont)
                //     .then(function(dataUrl) {
                //       doc.setFillColor(255, 255, 255);
                //       doc.roundedRect(14, 39, 186, 92, 1, 1, "FD");
                //       doc.addImage(dataUrl, "png", 15, 40, 60, 90);
                //     })
                //     .then(() => {
                //       doc.setFontSize(13);
                //       doc.setTextColor(79, 79, 79);
                //       doc.text(82, 55, "Map Route");

                //       doc.setFontSize(9);
                //       doc.setTextColor(134, 147, 165);

                //       doc.text(82, 70, "Start Date:");
                //       doc.text(82, 80, "Latitude:");
                //       doc.text(82, 90, "Longitude:");

                //       // doc.text(82, 82, "Distance Covered:");

                //       doc.text(142, 70, "End Date:");
                //       doc.text(142, 80, "Latitude:");
                //       doc.text(142, 90, "Longitude:");

                //       // doc.text(142, 82, "Alarms:");

                //       doc.setTextColor(51, 51, 51);

                //       doc.text(
                //         96,
                //         70,
                //         `${moment(
                //           `${this.startdate} ${this.starttime}`,
                //           "YYYY-M-D H:m",
                //           true
                //         ).format("ddd, MMM Do YYYY, hh:mm a")}`
                //       );

                //       doc.text(
                //         94,
                //         80,
                //         `${this.record.stats[0].latitude}`
                //       );
                //       let index = this.record.stats.length - 1;
                //       doc.text(
                //         97,
                //         90,
                //         `${this.record.stats[0].longitude}`
                //       );

                //       // doc.text(107, 82, "45km");

                //       doc.text(
                //         156,
                //         70,
                //         `${moment(
                //           `${this.enddate} ${this.endtime}`,
                //           "YYYY-M-D H:m",
                //           true
                //         ).format("ddd, MMM Do YYYY, hh:mm a")}`
                //       );
                //       doc.text(
                //         154,
                //         80,
                //         `${this.record.stats[index].latitude}`
                //       );
                //       doc.text(
                //         157,
                //         90,
                //         `${this.record.stats[index].longitude}`
                //       );
                this.isLoading = false;

                doc.save(
                  `${this.record.record.name}_${this.record.record.device}.pdf`
                );

                // doc.text(153, 82, "Alarms");
                //     });
                // }, 1000);
              }
            });
        }, 1000);
      }
    },
    closeExport() {
      if (this.exportShow == true) {
        this.exportShow = false;
      }
    },
    showGraph(type) {
      if (type == "temp") {
        this.tempGraph = true;
        this.humiGraph = false;
      }
      if (type == "humi") {
        this.humiGraph = true;
        this.tempGraph = false;
      }
    },
  },
};
</script>

<style scoped>
.mylink {
  color: #213e7a !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-decoration-color: #213e7a !important;
}
.tooltip {
  position: relative;
  display: inline-block;
  opacity: 1;
}
.tooltip .tooltiptext {
  width: 120px;
  bottom: 100%;
  left: 50%;
  margin-left: -60px; /* Use half of the width (120/2 = 60), to center the tooltip */
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1070;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}
@media (max-width: 767px) {
  .deleterecord {
    display: flex;
    margin-top: 3px;
    justify-content: flex-start !important;
  }
}
.deleterecord {
  display: flex;
  justify-content: flex-end;
}
.btn-container {
  display: flex;
  justify-content: center;
  width: 50%;
}
#graphselect {
  background-color: inherit;
  border: none;
  color: #213e7a;
  padding: 7px 25px;
  border-radius: 30px;
  outline: none;
}
#graphselect:hover {
  background-color: #213e7a;
  color: white;
}
#graphselect:disabled,
#graphselect[disabled] {
  background-color: #DEE2EB;
  color: #213e7a;
}
</style>

<i18n>
{
	"en": {
		"back-to": "Back to Records",
		"del_perm": "Delete this record permanently? This action is not reversible",
		"del_rec": "Delete Record",
		"exp": "Export",
		"exp-csv": "Export as CSV",
		"exp-pdf": "Export as PDF",
		"feature": "This feature is only available with the premium plan",
		"from": "From",
		"no-temp-humid": "No Temperature/Humidity data available for this period",
		"to": "To"
	},
	"es": {
		"back-to": "Volver a Records",
		"del_perm": "¿Eliminar este registro de forma permanente? Esta acción no es reversible",
		"del_rec": "Eliminar el registro",
		"exp": "Exportar",
		"exp-csv": "Exportar como CSV",
		"exp-pdf": "Exportar como PDF",
		"feature": "Esta función solo está disponible con el plan premium",
		"from": "Desde",
		"no-temp-humid": "No hay datos de temperatura / humedad disponibles para este período",
		"to": "a"
	},
	"fr": {
		"back-to": "Retour aux enregistrements",
		"del_perm": "Supprimer définitivement cet enregistrement ? Cette action n'est pas réversible",
		"del_rec": "Supprimer l'enregistrement",
		"exp": "Exportation",
		"exp-csv": "Exporter au format CSV",
		"exp-pdf": "Exporter en PDF",
		"feature": "Cette fonctionnalité n'est disponible qu'avec le plan premium",
		"from": "De",
		"no-temp-humid": "Aucune donnée de température/humidité disponible pour cette période",
		"to": "à"
	},
	"sw": {
		"back-to": "Rudi kwenye Rekodi",
		"del_perm": "Je, ungependa kufuta rekodi hii kabisa? Kitendo hiki hakiwezi kutenduliwa",
		"del_rec": "Futa Rekodi",
		"exp": "Uuzaji nje",
		"exp-csv": "Hamisha kama CSV",
		"exp-pdf": "Hamisha kama PDF",
		"feature": "Kipengele hiki kinapatikana kwa mpango wa malipo pekee",
		"from": "Kutoka",
		"no-temp-humid": "Hakuna data ya Halijoto/Unyevu inayopatikana kwa kipindi hiki",
		"to": "Kwa"
	}
}
</i18n>
